<template lang="pug">
  div
    b-row
      .col-xl-10
        panel(:title='$t("ui.daily_winlose_match")' reportDetails=1)
          b-card
            b-row.flex(slot="header")
              .col-sm-12.col-md-6.col-lg-8.col-xl-6.mb-1
                DatePicker
              pendingMatches.mb-1
              .col-sm-12.col-md-12.col-lg-12.col-xl-12.mb-1
                b-alert.alert-sm.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
              .col-sm-12.col-md-12.col-lg-12.col-xl-12.d-flex
                SubmitButton(:loading="loading" icon="fa fa-search" :text="$t('ui.search')" isModal=false type="button" @click="submit")
                .ml-auto
                  jsonToExcel(v-if="dailyWinloseMatchList.length > 0" mode="WinloseByMatch" :date="dateRange")
            b-row.mb-2
              .col-sm-12.col-md-12.col-lg-12.col-xl-12
                b-breadcrumb.bg-grey-transparent-3.p-l-10
                  b-breadcrumb-item.text-uppercase(
                    :text="$t('ui.sportsbook')"
                    @click="redirectTo(0)"
                  )
                  b-breadcrumb-item.text-uppercase(
                    v-if="leagueTable || matchTable || matchMemberTable"
                    :text="$t('ui.' + getSportType.toLowerCase())"
                    @click="redirectTo(1)"
                  )
                  b-breadcrumb-item.text-uppercase(
                    v-if="matchTable || matchMemberTable"
                    :text="getName(getLeagueID.id, 0)"
                    @click="redirectTo(2)"
                  )
                  b-breadcrumb-item.text-uppercase(
                    v-if="matchMemberTable"
                    :text="getName(getMatchID.id, 1) + ' VS ' + getName(getMatchID.id, 2)"
                    @click="redirectTo(3)"
                  )
            sportTypeWinlose(v-if="sportTypeTable" :list="dailyWinloseMatchList" @clicked="getLeagueWinlose")
            leagueWinlose(v-else-if="leagueTable" :list="dailyWinloseMatchList" :total="dailyWinloseGrandTotal" :totalRows="totalRows" @clicked="getMatchWinlose" :match="match" :league="league" @refresh="getLeagueWinlose")
            matchWinlose(v-else-if="matchTable" :list="dailyWinloseMatchList" :total="dailyWinloseGrandTotal" :totalRows="totalRows" @clicked="getMatchMemberWinlose" :match="match" :league="league" @refresh="getMatchWinlose")
            matchMemberWinlose(v-else="matchMemberTable" :list="dailyWinloseMatchList" :total="dailyWinloseGrandTotal" :totalRows="totalRows" @refresh="getMatchMemberWinlose")
</template>

<script>
import config from "@/config";
import SubmitButton from "@/library/SubmitButton.vue";
import DateRangePicker from "@/library/DateRangePicker.vue";
import pendingMatches from "@/components/report/pendingMatches.vue";
import DatePicker from "@/library/DatePicker.vue";
import sportTypeWinlose from "@/components/report/sportTypeWinloseDetail.vue";
import leagueWinlose from "@/components/report/leagueWinloseDetail.vue";
import matchWinlose from "@/components/report/matchWinloseDetail.vue";
import matchMemberWinlose from "@/components/report/matchMemberWinloseDetail.vue";
import jsonToExcel from "@/library/jsonToExcel.vue";

export default {
  components: {
    SubmitButton,
    DateRangePicker,
    pendingMatches,
    sportTypeWinlose,
    leagueWinlose,
    matchWinlose,
    matchMemberWinlose,
    DatePicker,
    jsonToExcel
  },
  data() {
    return {
      loading: false,
      submission: {
        success: true,
        status: ""
      },
      downlineLevel: this.$store.getters.accountType,
      dailyWinloseMatchList: [],
      dailyWinloseGrandTotal: [],
      sportTypeTable: true,
      leagueTable: false,
      matchTable: false,
      matchMemberTable: false,
      match: [],
      league: [],
      totalRows: 0
    };
  },
  validations: {},
  computed: {
    dateRange() {
      return {
        startDate: this.$moment(this.$store.getters.dateRange.startDate).format("YYYY-MM-DD"),
        endDate: this.$moment(this.$store.getters.dateRange.endDate).format("YYYY-MM-DD")
      }
    },
    getProduct() {
      return this.$store.getters.getPlatform
    },
    getSportType() {
      return this.$store.getters.getSportType
    },
    getLeagueID() {
      return this.$store.getters.getLeagueID
    },
    getMatchID() {
      return this.$store.getters.getMatchID
    },
    language() {
      if(this.$store.getters.language == "zh") {
        return "cn"
      } else {
        return this.$store.getters.language
      }
    },
    perPage() {
      return this.$store.getters.pageSize
    },
    pageDetail() {
      return this.$store.getters.getPageDetail
    }
  },
  mounted: function() {
    let page = {
      currentPage: 1,
      perPage: this.perPage,
      sortBy: "",
      direction: "ASC"
    }
    this.$store.dispatch("layout/setPageDetail", page)
    this.submit()
  },
  methods: {
    initTable: function() {
      this.sportTypeTable = true
      this.leagueTable = false
      this.matchTable = false
      this.matchMemberTable = false
    },
    submit: function() {
      this.initTable()
      this.getSportTypeWinlose()
    },
    redirectTo: function(index){
      let page = {
        currentPage: 1,
        perPage: this.perPage,
        sortBy: "",
        direction: "ASC"
      }
      this.$store.dispatch("layout/setPageDetail", page)
      switch(index) {
        case 0:
          this.sportTypeTable = true
          this.leagueTable = false
          this.matchTable = false
          this.matchMemberTable = false
          this.getSportTypeWinlose()
          break
        case 1:
          this.sportTypeTable = false
          this.leagueTable = true
          this.matchTable = false
          this.matchMemberTable = false
          this.getLeagueWinlose()
          break
        case 2:
          this.sportTypeTable = false
          this.leagueTable = false
          this.matchTable = true
          this.matchMemberTable = false
          this.getMatchWinlose()
          break
        case 3:
          this.sportTypeTable = false
          this.leagueTable = false
          this.matchTable = false
          this.matchMemberTable = true
          this.getMatchMemberWinlose()
          break
      }
    },
    getSportTypeWinlose: function() {
      this.sportTypeTable = true
      let url = config.getSportTypeWinloseDetailUrl()
      let api = "user/getSportTypeWinlose"
      this.getDrillIn({url, api})
    },
    getLeagueWinlose: function() {
      this.sportTypeTable = false
      this.leagueTable = true
      let url = config.getLeagueWinloseDetailUrl()
      let api = "user/getLeagueWinlose"
      let sport_type = this.getSportType
      this.getDrillIn({url, api, sport_type})
    },
    getMatchWinlose: function() {
      this.leagueTable = false
      this.matchTable = true
      let url = config.getMatchWinloseDetailUrl()
      let api = "user/getMatchWinlose"
      let sport_type = this.getSportType
      let league_id = this.getLeagueID.id
      this.getDrillIn({url, api, sport_type, league_id})
    },
    getMatchMemberWinlose: function() {
      this.matchTable = false
      this.matchMemberTable = true
      let url = config.getMatchMemberWinloseDetailUrl()
      let api = "user/getMatchMemberWinlose"
      let sport_type = this.getSportType
      let league_id = this.getLeagueID.id
      let match_id = this.getMatchID.id
      this.getDrillIn({url, api, sport_type, league_id, match_id})
    },
    getName: function(id, mode) {
      let name = ""
      if(mode == 0) {
        this.league.forEach(x => {
          if(x.league_id == id) {
            name = (x["name_" + this.language]) ? x["name_" + this.language] : x["name_en"]
          }
        })
      } else {
        this.match.forEach(y => {
          if(y.match_id == id) {
            if (mode == 1) {
              name = (y["home_name_" + this.language]) ? y["home_name_" + this.language] : y["home_name_en"]
            } else {
              name = (y["away_name_" + this.language]) ? y["away_name_" + this.language] : y["away_name_en"]
            }
          }
        })
      }
      return name
    },
    getDrillIn: function(detail) {
      if (!this.$v.$invalid) {
        let url = detail.url
        let search_id = this.$store.getters.accountID
        let start_date = this.dateRange.startDate
        let end_date = this.dateRange.endDate
        let sport_type = detail.sport_type
        let league_id = detail.league_id
        let match_id = detail.match_id
        let page_number = this.pageDetail.currentPage;
        let page_size = this.pageDetail.perPage;
        let sort_key = this.pageDetail.sortBy;
        let sort_type = this.pageDetail.direction;
        this.loading = true
        this.$store
          .dispatch(detail.api, { url, search_id, start_date, end_date, sport_type, league_id, match_id, page_number, page_size, sort_key, sort_type })
          .then(response => {
            this.loading = false
            this.submission.success = response.success
            this.submission.status = response.errorTag
            if (this.submission.success == true) {
              if(response.data.length > 0) {
                this.dailyWinloseMatchList = response.data
                if(response.grandTotal) {
                  this.dailyWinloseGrandTotal = response.grandTotal
                }
                this.totalRows = response.data.length > 0 ? this.dailyWinloseMatchList[0]["totalrows"] : 0;

                if(detail.api == "user/getLeagueWinlose") {
                  this.league = response.names.league
                }

                if(detail.api == "user/getMatchWinlose") {
                  this.match = response.names.match
                  this.league = response.names.league
                }
              } else {
                this.totalRows = 0
                this.dailyWinloseMatchList = []
                this.dailyWinloseGrandTotal = []
                this.match = []
                this.league = []
              }
            } else {
              this.loading = false
              this.submission.success = response.success
              this.submission.status = response.errorTag
            }
          })
          .catch(response => {
            this.loading = false
            this.totalRows = 0
            this.dailyWinloseMatchList = []
            this.dailyWinloseGrandTotal = []
            this.match = []
            this.league = []
            this.submission.success = response.success
            this.submission.status = this.$t("message." + response.errorTag)
          });
      }
    }
  }
};
</script>